import { useMemo } from "react";
import DOMPurify from "dompurify";

interface FooterWordPressContentProps {
  contentHtml: string;
}

const FooterWordPressContent = ({ contentHtml }: FooterWordPressContentProps) => {
  const sanitizedHtml = useMemo(
    () => DOMPurify.sanitize(contentHtml, { USE_PROFILES: { html: true } }),
    [contentHtml]
  );

  return (
    <div
      className="footer-wordpress-content"
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
};

export default FooterWordPressContent;
